module.exports = __webpack_public_path__ + "static/media/playlists.52a9d9cf.svg";